const Loading = () => {
    return <></>;
};
export default Loading;
